module.exports = __webpack_public_path__ + "assets/img/ztLOGO.23578cb5.png";